import { FC } from "react";
import { useSelector } from "react-redux";

import { EventTravelLegs } from "Bands/containers";
import {
  PassengerTable,
  TravelMap,
} from "Bands/pages/event-travel-block/containers";
import { eventBlockSelectorCreator } from "Bands/state";
import { EventBlocks, IEventTravelBlock } from "Bands/types";
import { mapUserPermissions } from "shared/utils";
import { NotFlexSpacer } from "../EventSchedule/styles";

interface Props {
  blockId: string;
  showPersonalInfo?: boolean;
  isPrint?: boolean;
}

export const EventTravelBlock: FC<Props> = ({
  blockId,
  showPersonalInfo = true,
  isPrint,
}) => {
  const blockSelector = eventBlockSelectorCreator(blockId, EventBlocks.travel);
  const block = useSelector(blockSelector) as IEventTravelBlock;

  if (!block) return null;

  return (
    <NotFlexSpacer size="l">
      <TravelMap travelLegs={block.travelLegs} />
      <EventTravelLegs
        blockId={block.id}
        travelLegs={block.travelLegs}
        showPersonalTicket={showPersonalInfo}
      />
      {mapUserPermissions(block.permissions || []).VIEW_PASSENGERS && (
        <PassengerTable
          blockId={blockId}
          travelLegs={block.travelLegs}
          showActions={false}
          isPrint={isPrint}
        />
      )}
    </NotFlexSpacer>
  );
};
